import Link from 'next/link'
import s from './MenuSidebarView.module.scss'
import { Text } from '@components/ui'
import { useUI } from '@components/ui/context'
import SidebarLayout from '@components/common/SidebarLayout'

import type { Link as LinkProps } from './index'
import NavBlocks from '@components/common/NavOverlay/NavBlocks'
import cn from 'clsx'

export default function MenuSidebarView({
  links = [],
}: {
  links?: LinkProps[]
}) {
  const { closeSidebar } = useUI()

  const noActionLinks = links?.filter((l) => !(l as any).action)

  return (
    <SidebarLayout handleClose={() => closeSidebar()}>
      <div className={cn(s.root, s.preview)}>
        <NavBlocks />

        <nav>
          <ul>
            {noActionLinks.map((l: any) => (
              <li
                key={l.href}
                className={s.item}
                onClick={() => closeSidebar()}
              >
                <Link href={l.href}>
                  <a>
                    <Text variant="smallText">{l.label}</Text>
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </SidebarLayout>
  )
}
